import React, { useState, useRef, useEffect } from 'react';

export const Collapsible = ({ 
  children, 
  isOpen, 
  className = "" 
}) => {
  const [height, setHeight] = useState(0);
  const contentRef = useRef(null);

  useEffect(() => {
    if (contentRef.current) {
      const scrollHeight = contentRef.current.scrollHeight;
      setHeight(isOpen ? scrollHeight : 0);
    }
  }, [isOpen, children]);

  return (
    <div
      className={`overflow-hidden transition-all duration-300 ease-in-out ${className}`}
      style={{ maxHeight: `${height}px` }}
    >
      <div ref={contentRef}>
        {children}
      </div>
    </div>
  );
};

export default Collapsible;

